import { checkAccessToPath } from 'frontend/common/access-helpers'
import { computed } from 'vue'

export function useImportsSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }
  const section = computed(() => {
    const result = {
      name: 'Imports',
      items: [
        {
          title: 'Drivers',
          path: 'driver-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subIcon: {
              iconClasses: 'mi-outlined mi-badge',
            },
          },
        },
        {
          title: 'Vehicles',
          path: 'vehicle-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subIcon: {
              iconClasses: 'mi-outlined mi-directions-car',
            },
          },
        },
        {
          title: 'Clients',
          path: 'client-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subIcon: {
              iconClasses: 'mi-outlined mi-recent-actors',
            },
          },
        },
        {
          title: 'Transport Booking',
          path: 'transport-booking-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subIcon: {
              iconClasses: 'mi-outlined mi-commute',
            },
          },
        },
        {
          title: 'Transportation Point',
          path: 'transportation-point-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subScript: 'TP',
            subScriptPosition: 'bottom-right',
            subScriptShape: 'square',
          },
        },
        {
          title: 'User Accesses',
          path: 'user-access-imports',
          icon: {
            iconClasses: 'mi-outlined mi-insert-drive-file',
            subIcon: {
              iconClasses: 'mi-outlined mi-account-circle',
            },
          },
        },
      ],
    }

    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
